import { createContext, useMemo } from 'react';

type InteractiveDescriptionContextType = {
  imageMap: ImageMap | null;
  clickedItem: Area | null;
  setClickedItem: (clickedItem: Area | null) => void;
  contentWhenClicked: Description | null;
  setContentWhenClicked: (description: Description | null) => void;
  isChild: boolean;
  infoText: string;
  contentHeadline: string;
  isSectionReference: boolean;
  handleCloseDescription: () => void;
};

export const InteractiveDescriptionContext = createContext({
  imageMap: null,
  clickedItem: null,
  setClickedItem: () => {},
  contentWhenClicked: null,
  setContentWhenClicked: () => {},
  isChild: false,
  infoText: '',
  contentHeadline: '',
  isSectionReference: false,
  handleCloseDescription: () => {},
} as InteractiveDescriptionContextType);

export function InteractiveDescriptionContextProvider({
  imageMap,
  clickedItem,
  setClickedItem,
  contentWhenClicked,
  setContentWhenClicked,
  isChild,
  infoText,
  contentHeadline,
  isSectionReference,
  handleCloseDescription,
  children,
}: React.PropsWithChildren<InteractiveDescriptionContextType>) {
  const value = useMemo(
    () => ({
      imageMap,
      clickedItem,
      setClickedItem,
      contentWhenClicked,
      setContentWhenClicked,
      isChild,
      infoText,
      contentHeadline,
      isSectionReference,
      handleCloseDescription,
    }),
    [
      imageMap,
      clickedItem,
      setClickedItem,
      contentWhenClicked,
      setContentWhenClicked,
      isChild,
      infoText,
      contentHeadline,
      isSectionReference,
      handleCloseDescription,
    ],
  );

  return (
    <InteractiveDescriptionContext.Provider value={value}>
      {children}
    </InteractiveDescriptionContext.Provider>
  );
}
